import { Link } from "react-router-dom";

export default function PriceTableFive(){
    return(
        <section class="core-feature-area pt-100 pt-md-60 pt-xs-120 pb-100 pb-md-30 pb-xs-30 home-5">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<div class="section-title text-center mb-55">
							<p class="lh-1 mb-10">Price &amp; Plans</p>
							<h2 class="sect-title">Flexible Plans</h2>
						</div>
					</div>
				</div>
				<div class="row gx-0">
					<div class="col-xl-4 col-lg-6 col-md-6">
						<div class="rts-pricing-table1 text-center mb-30">
							<div class="rts-pricing-icon">
								<img src="assets/img/home-5/basic.webp" alt="" />
							</div>
							<div class="rts-pricing-table-header">
								<h2 class="title">
									Basic Plan
								</h2>
							</div>
							<div class="rts-pricing-table-body">
								<div class="rts-pricing-table-price">
									<div class="rts-pricing-tag">
										<span class="currency">$</span>
										<span class="price-text">19</span>
										<span class="period">mo</span>
									</div>
								</div>
								<ul class="features-list">
									<li><span class="table-feature-text">Unlimited project</span></li>
									<li><span class="table-feature-text1">Power And Predictive Dialing</span></li>
									<li><span class="table-feature-text1">Quality &amp; Customer Experience</span></li>
									<li><span class="table-feature-text1">24/7 phone and email support</span></li>
								</ul>
								<div class="btn-part">
									<Link to="#" class="rts-pricing-table-btn">Get Trail 1 Month</Link>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-4 col-lg-6 col-md-6">
						<div class="rts-pricing-table2 text-center mb-30">
							<div class="rts-pricing-icon">
								<img src="assets/img/home-5/h4-price-top-icon-advance.webp" alt="" />
							</div>
							<div class="rts-pricing-table-header">
								<h2 class="title">
									Advance Plan
								</h2>
							</div>
							<div class="rts-pricing-table-body">
								<div class="rts-pricing-table-price">
									<div class="rts-pricing-tag">
										<span class="currency">$</span>
										<span class="price-text">49</span>
										<span class="period">mo</span>
									</div>
								</div>
								<ul class="features-list">
									<li><span class="table-feature-text">Unlimited project</span></li>
									<li><span class="table-feature-text1">Power And Predictive Dialing</span></li>
									<li><span class="table-feature-text1">Quality &amp; Customer Experience</span></li>
									<li><span class="table-feature-text1">24/7 phone and email support</span></li>
								</ul>
								<div class="btn-part">
									<Link to="#" class="rts-pricing-table-btn">Get Trail 1 Month</Link>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xl-4 col-lg-6 col-md-6">
						<div class="rts-pricing-table1 text-center mb-30">
							<div class="rts-pricing-icon">
								<img src="assets/img/home-5/h4-price-top-icon.webp" alt="" />
							</div>
							<div class="rts-pricing-table-header">
								<h2 class="title">
									Premium Plan
								</h2>
							</div>
							<div class="rts-pricing-table-body">
								<div class="rts-pricing-table-price">
									<div class="rts-pricing-tag">
										<span class="currency">$</span>
										<span class="price-text">99</span>
										<span class="period">mo</span>
									</div>
								</div>
								<ul class="features-list">
									<li><span class="table-feature-text">Unlimited project</span></li>
									<li><span class="table-feature-text1">Power And Predictive Dialing</span></li>
									<li><span class="table-feature-text1">Quality &amp; Customer Experience</span></li>
									<li><span class="table-feature-text1">24/7 phone and email support</span></li>
								</ul>
								<div class="btn-part">
									<Link to="#" class="rts-pricing-table-btn">Get Trail 1 Month</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
    )
}